import { html } from 'lit';
import { queryAssignedElements } from 'lit/decorators.js';
import { CrntElement } from '../../lib/crnt-element.js';
import { CrntButtonBaseMixin } from '../button-base/button-base-mixin.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class CrntButtonAlt extends CrntButtonBaseMixin(CrntElement) {
  static {
    /** ==================================================================================================================
     * @region Internal logic
     ================================================================================================================== */
    this.tagName = "crnt-button-alt";
  }
  _disableControl() {
    this._controls?.forEach((control) => {
      const disabledClickListener = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
      };
      if (this._isDisabled) {
        control.addEventListener("click", disabledClickListener);
        control.setAttribute("aria-disabled", "true");
      } else {
        control.removeEventListener("click", disabledClickListener);
        control.removeAttribute("aria-disabled");
      }
    });
  }
  /** ==================================================================================================================
   * @region Lifecycle events
   ================================================================================================================== */
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    this._disableControl();
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    if (changedProperties.has("state")) {
      this._disableControl();
    }
  }
  /** ==================================================================================================================
   * @region Render methods
   ================================================================================================================== */
  render() {
    return html`
			<div part="container">
				<div part="leading">
					<slot name="leading"></slot>
				</div>
				<div part="content">
					<slot></slot>
				</div>
				<div part="trailing">
					<slot name="trailing"></slot>
					<slot name="fixed-trailing"></slot>
				</div>
			</div>
		`;
  }
}
__decorateClass([
  queryAssignedElements({ selector: "button, a" })
], CrntButtonAlt.prototype, "_controls");

export { CrntButtonAlt };
